// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) { return "chunks/" + {"367":"confetti","644":"draggable"}[chunkId] + "." + {"367":"83a8c90a","644":"c7130013"}[chunkId] + ".js"; };